import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviouralConcernDialogData, BehaviouralConcernDialogResult } from '../../models/leap-v2-attendance.model';

/**
 * Raises ONE behavioural concern for a student on this session. Once a concern exists the dialog opens
 * read-only (data.existingConcern) — the API is insert-only and the rule is one per student per session.
 * Closing with a result is the caller's cue to POST it; nothing is persisted from here.
 */
@Component({
  selector: 'leap-v2-behavioural-concern-dialog',
  templateUrl: './leap-v2-behavioural-concern-dialog.component.html',
  styleUrls: ['./leap-v2-behavioural-concern-dialog.component.css'],
  standalone: false,
})
export class LeapV2BehaviouralConcernDialogComponent {
  reason = '';
  comments = '';

  readonly reasons = ['Disruption', 'Disengagement or refusal', 'Verbal aggression', 'Physical aggression', 'Other'];

  constructor(
    public dialogRef: MatDialogRef<LeapV2BehaviouralConcernDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BehaviouralConcernDialogData
  ) {}

  get readOnly(): boolean {
    return !!this.data.existingConcern;
  }

  get isValid(): boolean {
    return !!this.reason && !!this.comments.trim();
  }

  save(): void {
    if (this.readOnly || !this.isValid) return;
    const result: BehaviouralConcernDialogResult = {
      reason: this.reason,
      comments: this.comments.trim(),
    };
    this.dialogRef.close(result);
  }
}
